<template>
    <div class="">
        <page-header title="Create New Consolidation" breadcrumb="Bookings & Shipments > Load Consolidation > Create New" :back="-1" />
         <div class="px-3 py-4 bg-white mt-5">
             <components :is="currentPage"></components>
         </div>
    </div>
</template>

<script>
import AllRoute from "./modules/all-routes.vue"
import AddShipment from "./modules/add-shipments.vue"
import PageHeader from "@/components/UI/NewPageHeader";
import selectFleet from "./modules/select-fleet.vue";

export default {
    components: {
        AllRoute,
        AddShipment,
        PageHeader,
        selectFleet
    },
    computed: {
        currentPage(){
            // return AllRoute
            // return AddShipment
            return selectFleet
        }
    },
       
}
</script>
